import { curry, go, map } from 'fxjs/es';
import { zipWithIndex } from '@fxts/core';

export const mapIndexed = curry((fn, arr) => {
  return go(
    zipWithIndex(arr),
    map(([index, item]) => fn(item, index)),
  );
});
